import { useCallback, useMemo, useState } from 'react'

import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { isEqual } from 'lodash'
import { CTRListRequest, CTRListResponse } from '~bank-bsa-reporting/types'

export const CTR_LIST_WEBPAGE_KEY = 'ctr-list-webpage'

const useGetList = (opts: CTRListRequest) =>
  useQuery({
    queryKey: [CTR_LIST_WEBPAGE_KEY, opts],
    queryFn: () => Request.post<CTRListResponse, CTRListRequest>(Request.urls.bank.ctrListWebpage, opts),
    placeholderData: keepPreviousData
  })

const defaultFilter = (): CTRListRequest => ({
  filingType: null,
  page: 1,
  size: 50,
  status: null,
  transactionDate: null
})

export const useGetCTRList = (pdfFilter?: CTRListRequest) => {
  const [filter, setFilter] = useState<CTRListRequest>(defaultFilter())

  const { isFetching, data } = useGetList(pdfFilter ?? filter)

  const onFilterChange = useCallback(
    (value: Partial<CTRListRequest>) => {
      if (!isEqual(filter, value)) {
        setFilter({ ...filter, ...value })
      }
    },
    [filter]
  )

  const onClear = useCallback(() => {
    setFilter(defaultFilter)
  }, [])

  const tableConfig = useMemo(
    () => ({
      isFetching,
      onFilterChange,
      onClear
    }),
    [isFetching, onClear, onFilterChange]
  )

  return {
    data,
    isFetching,
    tableConfig
  }
}
